import { type IntlShape } from 'react-intl';

import { emailSubscriptionFormMessages } from './form-messages';

export interface BuildConsentTextsArgs {
	intl: IntlShape;
	showMarketingOptIn: boolean;
	showPrivacyAgreement: boolean;
	privacyPolicyHref: string;
	productFamilyHref: string;
	partnersHref: string;
}

export interface ConsentTexts {
	consentLabelText: string;
	privacyPolicyText: string;
}

// Consent hub stores the displayed text as HTML, so the messages' inline link tags
// are rendered to anchors. Only text actually displayed is recorded, so hidden copy
// submits as empty.
export const buildConsentTexts = (args: BuildConsentTextsArgs): ConsentTexts => {
	const {
		intl,
		showMarketingOptIn,
		showPrivacyAgreement,
		privacyPolicyHref,
		productFamilyHref,
		partnersHref,
	} = args;

	const consentLabel = intl.formatMessage(emailSubscriptionFormMessages.marketingOptIn, {
		atlassianLink: (chunks: string[]) => `<a href="${productFamilyHref}">${chunks.join('')}</a>`,
		partnersLink: (chunks: string[]) => `<a href="${partnersHref}">${chunks.join('')}</a>`,
	});
	const privacyAgreement = intl.formatMessage(emailSubscriptionFormMessages.privacyAgreement, {
		link: (chunks: string[]) =>
			`<a href="${privacyPolicyHref}" target="_blank">${chunks.join('')}</a>`,
	});

	return {
		consentLabelText: showMarketingOptIn ? `<p>${consentLabel}</p>\n` : '',
		privacyPolicyText: showPrivacyAgreement ? `<p>${privacyAgreement}</p>\n` : '',
	};
};
